const constants = {
  icons: {
    logo: "../images/logo.png",
    clockIcon: "../images/svg/clock.svg",
    trophy: "../images/throphy.png",
  },
  // home
  devName: "Moiz Hassan",
  schoolTiming: "8 AM - 5 PM, Monday - Saturday",
  copyRight: "Copyright © 2026 The Harvard School. All rights reserved. Developed by ",
  name: "The Harvard School",
  phone: "(048)3259773",
  email: "admin@harvardschool.edu.pk",
  location: "Officers Colony, Faisalabad Road, Sargodha",
  whatsappLink: "https://api.whatsapp.com/send/?phone=923006007600&text&type=phone_number&app_absent=0",
  facebookLink:
    "https://www.facebook.com/TheHarvardSchoolSargodhaPakistan/",
  instagramLink:
    "https://www.instagram.com/TheHarvardSchoolSargodhaPakistan/",
  tagLine: " First International standard school in Sargodha. Playgroup to Matric. Affiliated with Federal Board",
  // about
  aboutHero: {
    title: "About Us",
    subtitle:
      "Shaping bright futures through quality education and character building.",
    backgroundImage: "/images/vision2.jpg",
  },
  //   contact
  contactHero: {
    title: "Contact Us",
    subtitle: "We’d love to hear from you. Get in touch with us today!",
    backgroundImage: "/images/vision2.jpg",
  },
  galleryHero: {
    title: "Gallery",
    subtitle: "“Childhood should be a journey not a race”.",
    backgroundImage: "/images/vision2.jpg",
  },
  //   differenceSection
  differenceSection: {
    subheading1: "Certified Institute",
    subheading2: "Qualified Teacheres",
    heading1: "Federal Board Sargodha ",
    firstBoxText: "The Harvard School also follows national or regional curriculum standards to provide a comprehensive education. Additionally, implementing quality assurance measures helps  to maintain and improve the school’s academic programs.",
    secBoxText: "The Harvard School always requires teachers that have appropriate teaching degrees or certifications. To ensure they stay updated,   The Harvard School provides them the opportunity to  participate in ongoing professional development. Additionally,   The Harvard school  provides teachers with specialized training in specific subjects  to enhance their expertise. Finally, valuing teachers with classroom experience can contribute to effective instruction.",
    upperRightHeading: "What makes us different",
    upperRightText: "The Harvard  School’s unique identity is shaped by its philosophy, curriculum, extracurricular activities, culture, community involvement, leadership, and commitment to diversity and inclusion. These factors contribute to an overall appeal and significantly influence students’ experiences and outcomes  at The Harvard School."
  },
  //   Event
  eventSection: {
    Error: "Event not found",
    sideHeading: "Resent Events"
  },
  //   Facilities
  facilitySection: {
    heading: "Our Facilities",
    facilityText: " The Harvard School provides a supportive learning environment. Essential facilities include academic spaces like classrooms, libraries, and laboratories, as well as sports  and recreational facilities like playgrounds, fields, and a Basketball Ground. Administrative facilities such as the principal’s office and staff room are also crucial.Other important facilities include a cafeteria, medical room, computer lab, and counseling office. These facilities collectively contribute to a positive and conducive learning environment for students.",
    check1: "Cafeteria",
    check2: "Medical Room",
    check3: "Computer Lab",
    check4: "Counseling Office",
  },
  //footer
  footerSection: {
    heading1: "Quick Links",
    heading2: "School Hours",
    h1Subheading1: "Home",
    h1Subheading2: "About Us",
    h1Subheading3: "Gallery",
    h1Subheading4: "Contact Us",
  },
  //introSection
  introSection: {
    title: "Introduction About Our School",
    fnTitle1: "Active Students",
    fnTitle2: "Faculty Courses",
    fnTitle3: "Best Professors",
    fnTitle4: "Award Achieved",
    fn1TargetValue: "45",
    fn2TargetValue: "100",
    fn3TargetValue: "90",
    fn4TargetValue: "25",
    expirianceTitle: "YEARS OF EXPERIENCE",
    introVideoTitle: "Intro School Video",
    introVideoText: "The Harvard  School’s unique identity is shaped by its philosophy, curriculum, extracurricular activities, culture, community involvement, leadership, and commitment to diversity and inclusion."
  },
  //   latestNews
  latestNewsSection: {
    latesNewsTitle: "Latest Events",
    latestNewsDiscription: " Saepe quo labore aenean dictumst expedita commodi auctor, nisl, lorem iusto feugiat nemo reiciendis laboris.",
  },
  //mapSection
  map: {
    mapHeading: "Find Us on the Map",
  },
  //missionSection
  visionMission: {
    missionHeading: "Mission",
    motoTiltle: "The Harvard School Whose motto",
    motoText: "“Childhood should be a journey not a race”.",
    subText: "The Harvard School was established in 2005.",
    subDiscription: "The Harvard School follows this motto. Its curriculum is student-centered. It focuses on a child’s mental capacity at each stage of life and is appropriate to the age of the child. The Harvard School ensures that learners are not overburdened with concepts and tasks that a young mind cannot grasp. It opens its doors with a high aim for our toddlers and beginners. We facilitate students with indoor and outdoor activities. Quran education is also an integral part of The Harvard School education system. We are committed to providing a healthy environment and developing useful citizens for the community. The Harvard School works as a torchbearer with a focus on all learning styles. The Harvard School takes care of the individual learning needs of every student by delivering innovative and market-oriented quality education.",
    visionHeading: "VISION",
    visionText: " “At HARVARD SCHOOL, we envision a vibrant educational community where students are inspired to reach their fullest potential. Our commitment lies in nurturing a culture of curiosity, creativity, and collaboration, where every individual is valued and supported. Through personalized learning experiences and a dedication to excellence, we aim to equip our students with the knowledge, skills, and character traits needed to become responsible global citizens and leaders of tomorrow.”"
  },
  //principalSection
  principalMessageSection: {
    principalMasTitle1: "Principal's",
    principalMasTitle2: "message",
    principalMas: "  “Welcome to The Harvard School, where we nurture young minds to become exceptional individuals. Our dedicated faculty is committed to providing a rigorous academic environment that fosters critical  thinking, creativity, and a lifelong love of learning. Through our  holistic approach to education, we strive to develop well-rounded students who are both academically accomplished and compassionate  global citizens. We believe that every child has unique potential,  and our goal is to help each student reach their full potential. Join us on this exciting journey of discovery and growth”",
  },
  //teacherSection
  TeacherSection: {
    teacherHeaading: "Meet Our Best Teachers",

  }

};

export default constants;
